export default "/_next/static/images/Footerbg744-14b87e13ba1a3d09899fe3af707dbded.png";